import {putAll, showBeError, showSuccess, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {opt} from 'ts-opt';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';

import {adminAction, RemoveUsersFromBreederRoleAction} from '../action';

const tt = t('admin');

function* execute({payload: {roleId, breederId}}: RemoveUsersFromBreederRoleAction): SagaIterator {
    const response = yield* call(Api.endUserProfileBreederRoleBindingForRole, {roleId, breederId});

    if (response.isSuccess) {
        yield* put(adminAction.getManagementBreedersTableData(opt({action: 'refresh'}), opt(breederId)));
        yield putAll(showSuccess(
            tt('removeUsersFromRole'),
            tt('removeUsersFromRoleSuccess'),
            false,
            'removeUsersFromRole',
        ));
    } else {
        yield putAll(showBeError(response, tt('removeUsersFromRole')));
    }
}

/** Runs the admin saga that removes users from the selected breeder role. */
export function* removeUsersFromBreederRole(): SagaIterator {
    yield takeLatestF('admin/REMOVE_USERS_FROM_BREEDER_ROLE', execute);
}
